import React from "react";
/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import { useEffect } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import PushAdd from "./PushAdd";
import PushEdit from "./PushEdit";
import log from "../lib/log";
import { loginState, configState } from "../lib/State";
import token_login from "../lib/token_login";
import get_session from "../lib/get_session";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import { AppBar, Toolbar, IconButton } from "@mui/material";
import CenterSelect from "./CenterSelect";
import pr from "../lib/pr";
import get_login from "../lib/get_login";
import is_admin from "../lib/is_admin";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Push() {
  const [login, setLogin] = useState(loginState);
  const [loaded, setLoaded] = useState(false);
  const [rows, setRows] = useState([]);
  const [seq, setSeq] = useState(0);
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const token = localStorage.getItem("token");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [popPhone, setPopPhone] = useState("Hello");
  const [centers, setCenters] = useState([]);
  const [tcid, setTcid] = useState('');
  const [sname, setSname] = useState('');
  const [sphone, setSphone] = useState('');
  const open = Boolean(anchorEl);
  const [type, setType] = useState('');

  const columns = [
    { field: "id", headerName: "id", hide: true },
    { field: "regdate", headerName: "등록", width: 140, align: "center" },
    {
      field: "type",
      headerName: "발송구분",
      width: 140,
      align:"center"
    },    
    {
      field: "mname",
      headerName: "수신",
      width: 110,
      renderCell: (params) => {
        return (
          <Typography
            sx={{ p: 1 }}
            onMouseEnter={(event) => onPopoverOver(event, params.row.phone)}
            onMouseOut={onPopoverOut}
          >
            {params.row.mname}
          </Typography>
        );
      },
    },
    { field: "title", headerName: "제목", width: 140 },
    { field: "message", headerName: "메세지", width: 330 },
    { field: "cname", headerName: "센터명", width: 180, align: "center" },
  ];

  // const rows = [
  //   {
  //     id: 1,
  //     name: "Snow",
  //     phone: "000-0000-0000",
  //     sex: "남",
  //     age: 35,
  //     weight: 55,
  //   }
  // ];
 
  const onCloseAddPop = () => {
    setShowAdd(false);
  };

  const onOpenAdd = () => {
    setShowAdd(true);
  };

  // 수정팝업 닫기
  const onCloseEditPop = () => {
    setShowEdit(false);
    setSeq(0);
  };

  // 리스트
  const load_data = async () => {
    console.log("load_data");
    pr('tcid='+tcid);
    let result = await axios.post(configState.api + "/gympass_admin/push", {
      token: token,
      cid: login.cid,
      level: login.level,
      mcd: login.mcd,
      tcid: tcid,
      sname: sname,
      sphone: sphone,
      stype:type,
    });
    if (result.data.success === 1) {
      setRows(result.data.rows);
    } else {
      Swal.fire(result.data.msg);
      return;
    }
  };

  // ======================= //
  // 로그인
  // ======================= //
  const start = async () => {
    let result;
    result = await get_login();
    setLogin(result.data.login);
    result = await is_admin(result.data.login);
    if (!result) {
      window.location.href = "/";
    }
    setLoaded(true);
  };
  useEffect(() => {
    start();
  }, []);

  // 리스트
  useEffect(() => {    
    if (loaded && tcid !=='') {
      load_data();
    }
  }, [loaded, tcid]);

  // 팝업처리
  const onPopoverOver = (event, message) => {
    setPopPhone(message);
    setAnchorEl(event.currentTarget);
  };

  const onPopoverOut = (event) => {
    setAnchorEl(null);
  };

  const onSearchClick = async () => {
    load_data();
  };  

  // const onAfterUpdate = () => {
  //   load_data();    
  //   setShowEdit(false);    
  // }

  useEffect(()=>{
    if(seq>0) {
      setShowEdit(true);
    }
  },[seq]);

  return (
    <>
      {loaded === false ? (
        <Loading></Loading>
      ) : (
        <Layout login={login}>
          <Popover
            id="mouse-over-popover"
            sx={{
              pointerEvents: "none",
            }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            onClose={onPopoverOut}
            disableRestoreFocus
          >
            <Typography sx={{ p: 1 }}>{popPhone}</Typography>
          </Popover>

          <h3
            css={css`
              margin-top: 10px;
            `}
          >
            푸시관리
          </h3>
          
          <Box
            display="flex"
            css={css`
              text-align: right;
              max-width: 1300px;
              margin-bottom: 15px;
            `}
          >
           {/* 센터명 */}
           <CenterSelect                            
              login={login}
              tcidParent={tcid}
              setTcidParent={setTcid}
            />   
            <Box sx={{ flexGrow: 1 }}></Box>

            {login.level === '500' &&
              <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                onClick={onOpenAdd}
              >
                푸시발송
              </Button>
            }

          </Box>

          <Box display="flex" sx={{ mb:1 }}>
            {/* 이름 */}
            <Box>
              <TextField
                sx={{ width: 120 }}
                name="sname"
                label="이름"
                size="small"
                onChange={(e)=>setSname(e.target.value)}
                autoComplete="off"
              ></TextField>
            </Box>

            {/* 연락처 */}
            <Box>
              <TextField
                sx={{ width: 160, ml: 1 }}
                name="sphone"
                label="연락처"
                size="small"
                onChange={(e)=>setSphone(e.target.value)}
                autoComplete="off"
              ></TextField>
            </Box>

            {/* 메세지구분 */}
            <FormControl
              sx={{ml:1}}
            >
              <InputLabel id="demo-simple-select-label">메세지구분</InputLabel>
              <Select
                name="type"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                css={css`
                  width: 260px;
                `}
                label="메세지구분"
                size="small"
                value={type}
                onChange={(e) => setType(e.target.value)}
              >
                <MenuItem value="">선택</MenuItem>
                <MenuItem value="모든회원">모든회원</MenuItem>
                <MenuItem value="선택회원">선택회원</MenuItem>                
              </Select>
            </FormControl>
            
            <Button
              sx={{ ml: 1, fontSize:15 }}
              variant="contained"
              onClick={onSearchClick}
              size="small"
            >
              조회
            </Button>
          </Box> 

          <DataGrid
            css={css`
              max-width: 1300px;
              min-height: 500px;
            `}
            rows={rows}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[5]}
            checkboxSelection={false}            
            onRowClick={(params)=>{              
              setSeq(params.row.id);
              //onOpenEditPop();
            }}
          />

          {/* 등록팝업 */}
          <Dialog
            open={showAdd}
            fullWidth={true}
            maxWidth="sm"
            TransitionComponent={Transition}
            onClose={() => {}}
          >
            <AppBar sx={{ position: "static" }}>
              <Toolbar>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography style={{ fontSize: 18 }}>푸시발송</Typography>
                </Box>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={onCloseAddPop}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <PushAdd
              login={login}
              onClosePop={onCloseAddPop}
              onLoadData={load_data}
            ></PushAdd>
          </Dialog>

          <Dialog
            open={showEdit}
            TransitionComponent={Transition}
            onClose={() => {}}
            maxWidth="md"
          >
            <AppBar sx={{ position: "static" }}>
              <Toolbar>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography style={{ fontSize: 18 }}>수정</Typography>
                </Box>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={onCloseEditPop}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <PushEdit
              login={login}
              seq={seq}
              onClosePop={onCloseEditPop}
              onLoadData={load_data}              
            ></PushEdit>
          </Dialog>
        </Layout>
      )}
    </>
  );
}

export default Push;
